function updateBtn(btnID,varID) {
    const button = document.querySelector(btnID)
    const parent = button.closest("li")
    if (!button) return;
    const buttonData = button.dataset
    for (const [key, value] of Object.entries(buttonData)) {
        if (key == varID) {
            if (value == "null") {
                parent.classList.add("hidden");
            } else {
                button.href = value
                parent.classList.remove("hidden");
            }
            return;
        }
    };
}

function updateDataVarBtns(variantId) {
  document.querySelectorAll('.btn-datavar').forEach(li => {
    li.hidden = true;
  });
  document.querySelectorAll(`.btn-datavar[data-varid="${variantId}"]`).forEach(li => {
    li.hidden = false;
  });
}

FoxTheme?.pubsub?.subscribe("variant-change", ({ data }) => {
  const variant = data?.variant;
  updateBtn('#btn_sample', variant.id);
  updateDataVarBtns(variant.id);
});

document.addEventListener('DOMContentLoaded', () => {
  const initialVariantId = document.querySelector('form[action="/cart/add"] input[name="id"]')?.value
    || new URLSearchParams(window.location.search).get('variant');
  if (initialVariantId) updateDataVarBtns(initialVariantId);
});